module.exports = __webpack_public_path__ + "media/images/common/my_menu_order_history-051ea757a5b2a9f2602d22a1481c4b9e.png";